import { css } from 'lit';

export const style = css`
  .fs-form-field {
    padding-bottom: 1em;
  }

  fs-text-field {
    margin-bottom: 24px;
  }
`;
